import {CSSProperties, useEffect, useState} from "react";
import {Game} from "@game/game";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {Localisation} from "@components/localisation/localisation";
import {COLOURS} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    contents: {
        alignItems: "center",
        backgroundColor: COLOURS.parchment,
        display: "flex",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    dialog: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 16
    },
    error: {},
    errors: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 8
    },
    title: {
        color: COLOURS.forestGreen,
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontSize: "xx-large",
        fontWeight: "bold",
        margin: 0,
        textAlign: "center"
    },
    subtitle: {
        color: COLOURS.ink,
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontSize: "large",
        margin: 0
    }
};

interface ILoading {
    game: Game
}

export function Loading({game}: ILoading) {
    const [errors, setErrors] = useState<string[]>([]);
    const [localised, setLocalised] = useState(false);
    const [showErrors, setShowErrors] = useState(false)
    const handleClickShowErrors = () => setShowErrors(!showErrors);

    useEffect(() => {
        setLocalised(Localisation.initialised);
        if (! Localisation.initialised) {
            Localisation.events.delegates.add(() => setLocalised(Localisation.initialised));
        }
    }, []);
    useEffect(() => {
        const handleUpdate = () => {
            setErrors(game.errors);
        };

        game.events.delegates.add(handleUpdate);
        return () => game.events.delegates.remove(handleUpdate);
    }, []);
    if (! localised) {
        return null;
    }
    return (
        <div style={styles.contents}>
            <div style={styles.dialog}>
                <p style={styles.title}>
                    <LocalisedTypography content="LoadingTitle"/>
                </p>
                {errors.length === 0 ?
                    <p onClick={handleClickShowErrors} style={styles.subtitle}>
                        <LocalisedTypography content="LoadingSubtitle"/>
                    </p> :
                    <div style={styles.errors}>
                        <p onClick={handleClickShowErrors} style={styles.subtitle}>
                            <LocalisedTypography content="LoadingError"/>
                        </p>
                        <LocalisedTypography content="LoadingInformation"/>
                        {showErrors &&
                            <ul>
                                {game.errors.map((error, index) =>
                                    <li key={index}>
                                        <LocalisedTypography content={error}/>
                                    </li>
                                )}
                            </ul>
                        }
                    </div>
                }
            </div>
        </div>
    );
}